import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
} from "antd";
import { AppDispatch, RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  editProject,
  fetchCommunes,
  fetchPrefectures,
  fetchProjectDetails,
  fetchRegions,
} from "../../store/slices/projectSlice";
import dayjs from "dayjs";
import * as S from "./ProjectDetails.styles";
import toast from "react-hot-toast";

const { Option } = Select;

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const EditProjectFormDrawer: React.FC<Props> = ({ open, setOpen }) => {
  const { projectDetails } = useSelector((state: RootState) => state.projects);
  const dateFormat = "DD/MM/YYYY";
  const initialState = {
    id: projectDetails?.id || null,
    nom_du_projet: projectDetails?.nom_du_projet || "",
    numero_de_permis_de_construire:
      projectDetails?.numero_de_permis_de_construire || null,
    titre_foncier: projectDetails?.titre_foncier || null,
    promoteur: projectDetails?.promoteur || null,
    surface_fonciere: projectDetails?.surface_fonciere || null,
    surface_construite: projectDetails?.surface_construite || null,
    surface_vendable: projectDetails?.surface_vendable || null,
    // date_de_permis_de_construire: dayjs(
    //   projectDetails?.date_de_permis_de_construire,
    //   "DD/MM/YYYY"
    // ).isValid()
    //   ? dayjs(projectDetails?.date_de_permis_de_construire, "DD/MM/YYYY")
    //   : null,
    // date_permis_d_habiter: dayjs(
    //   projectDetails?.date_permis_d_habiter,
    //   "DD/MM/YYYY"
    // ).isValid()
    //   ? dayjs(projectDetails?.date_permis_d_habiter, "DD/MM/YYYY")
    //   : null,

    
  };

  const [form] = Form.useForm();
  const [formData, setFormData] = useState(initialState);
  const dispatch: AppDispatch = useDispatch();
  const { regions, prefectures, communes } = useSelector(
    (state: RootState) => state.projects
  );

  const regionsOptions = regions.map((region) => ({
    value: region.id,
    label: region.nom,
  }));
  const [saisirAdresseManuellement, setSaisirAdresseManuellement] =
    useState(false);
  const [isRegionSelected, setIsRegionSelected] = useState(false);
  const [isPrefectureSelected, setIsPrefectureSelected] = useState(false);
  const prefectureOptions = useMemo(() => {
    if (isRegionSelected) {
      return prefectures.map((prefecture) => ({
        value: prefecture.id,
        label: prefecture.nom,
      }));
    }
    return [];
  }, [prefectures, isRegionSelected]);

  const commmuneOptions = useMemo(() => {
    if (isPrefectureSelected) {
      return communes.map((commune) => ({
        value: commune.id,
        label: commune.nom,
      }));
    }
    return [];
  }, [communes, isPrefectureSelected]);

  const handleRegionSelect = async (regionId: number) => {
    console.log(regionId);
    await dispatch(fetchPrefectures(regionId));

    setIsRegionSelected(true);
  };

  const handlePrefectureSelect = async (prefectureId: number) => {
    await dispatch(fetchCommunes(prefectureId));
    setIsPrefectureSelected(true);
  };

  const handleProgrammationChange = (value: string[]) => {
    console.log(value);
  };

  const onClose = () => {
    setOpen(false);
    setIsPrefectureSelected(false);
    setIsRegionSelected(false);
    form.resetFields();
  };

  const onFinish = async (values: any) => {
    console.log("Received values of form:", values);
    const { id, ...newProject } = values;
    // Process the date fields
    const dateFormat = "DD/MM/YYYY";
    const dateFields = [
      "date_de_permis_de_construire",
      "date_permis_d_habiter",
    ];
    dateFields.forEach((field) => {
      if (newProject[field]) {
        const parsedDate = dayjs(newProject[field]); // Use dayjs for consistency
        if (parsedDate.isValid()) {
          newProject[field] = parsedDate.format(dateFormat);
        } else {
          newProject[field] = null; // Set to null if the date is invalid
        }
      }
    });
    console.log(newProject);
    await dispatch(editProject({ newProject, id }))
      .unwrap()
      .then(() => {
        toast.success("Projet modifié avec succès");
      })
      .catch((error: any) => {
        toast.error("Une erreur est survenue. Veuillez réessayer plus tard.");
      });

    await dispatch(fetchProjectDetails(id));
    onClose();
  };

  useEffect(() => {
    dispatch(fetchRegions());
  }, []);

  return (
    <>
      <Drawer
        title="Modifier les caractéristiques générales du projet"
        width={500}
        onClose={onClose}
        open={open}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
      >
        <Form
          initialValues={initialState}
          form={form}
          onFinish={onFinish}
          layout="vertical" /*hideRequiredMark*/
        >

          <Row style={{ width: "100%" }} justify={"center"}>
            <Col md={24} lg={24} xs={24} sm={24}>
              <Form.Item name="id" label="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="nom_du_projet"
                label="Nom du projet"
                rules={[
                  {
                    required: true,
                    message: "Veuillez saisir le nom du projet",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="titre_foncier" label="Titre Foncier">
                <Input />
              </Form.Item>
              <Form.Item
                name="numero_de_permis_de_construire"
                label="Numéro de permis de construire"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="promoteur"
                label="Promoteur/Aménageur"
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          
          <Row justify={"end"} style={{ width: "100%" }}>
            <Button style={{ marginRight: "10px" }} onClick={onClose}>
              Annuler
            </Button>
            <Button type="primary" htmlType="submit">
              Modifier
            </Button>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default EditProjectFormDrawer;
